<template>
  <w-settings-content-template>
    <div slot="content" style="width: 50%">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3">기본 패스워드</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" :disabled="pwSaveDisabled" @click="onSaveButtonClick('VMBASIC')">저장</el-button>
          <el-button :disabled="pwCancelDisabled" @click="loadFormData('VMBASIC')">취소</el-button>
        </div>
      </el-row>
      <el-row class="mr-b30">
        <div class="list form-list">
          <el-form label-width="200px" label-position="left">
            <el-form-item label="패스워드">
              <el-input v-model="basicinfo['VMBASIC/VM_DEFAULT_PASSWORD'].value" @keyup.native="changeTargetValue(arguments[0].target.value, ...'VMBASIC/VM_DEFAULT_PASSWORD')"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box title-h3">회수/폐기 설정</div>
        <div class="vertical-center-box">
          <el-button class="mr-r4" type="primary" :disabled="expireSaveDisabled" @click="onSaveButtonClick('VMEXPIRE')">저장</el-button>
          <el-button :disabled="expireSaveDisabled" @click="loadFormData('VMEXPIRE')">취소</el-button>
        </div>
      </el-row>
      <el-row>
        <div class="list form-list">
          <el-form :model="basicinfo" label-width="200px" label-position="left">
            <el-form-item label="회수 알람">
              <el-input v-model.number="basicinfo['VMEXPIRE/VMEXPIRE_NOTIFY_DATE'].value" type="number" style="width: calc(100% - 60px)"
              @keyup.native="changeTargetValue(arguments[0].target.value, ...'VMEXPIRE/VMEXPIRE_NOTIFY_DATE')" @change="changeTargetValue(...arguments, ...'VMEXPIRE/VMEXPIRE_NOTIFY_DATE')"></el-input>
              <span class="mr-l4">일 전</span>
            </el-form-item>
            <el-form-item label="회수 후 폐기 여부">
              <el-switch v-model="basicinfo['VMEXPIRE/VMEXPIRE_AUTO_DELETE'].value" active-value="1" inactive-value="0" @change="changeTargetValue(arguments[0], ...'VMEXPIRE/VMEXPIRE_AUTO_DELETE')"></el-switch>
            </el-form-item>
            <el-form-item label="회수 후 폐기 날짜">
              <el-input v-model.number="basicinfo['VMEXPIRE/VMEXPIRE_DATE'].value" type="number" :disabled="!isTrue(basicinfo['VMEXPIRE/VMEXPIRE_AUTO_DELETE'].value)"
               style="width: calc(100% - 60px)" @keyup.native="changeTargetValue(arguments[0].target.value, ...'VMEXPIRE/VMEXPIRE_DATE')" @change="changeTargetValue(...arguments, ...'VMEXPIRE/VMEXPIRE_DATE')"></el-input>
               <span class="mr-l4">일 후</span>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </w-settings-content-template>
</template>

<script>
import { camelCase, cloneDeep, isEqual, mapKeys } from 'lodash';
import basicinfoSetAPI from '@/api/model/basicinfo-set';
import provisioningSettingsAPI from '@/api/settings/virtual/provisioning-settings';
import msgUtil from '@/utils/message';
import { isTrue } from '@/utils/boolean';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';

export default {
  name: 'WBasicInfoSetting',
  components: {
    WSettingsContentTemplate,
  },
  data() {
    return {
      basicinfo: {
        'VMBASIC/VM_DEFAULT_PASSWORD': {},
        'VMEXPIRE/VMEXPIRE_NOTIFY_DATE': {},
        'VMEXPIRE/VMEXPIRE_DATE': {},
        'VMEXPIRE/VMEXPIRE_AUTO_DELETE': {},
      },
      originBasicinfo: {},
    };
  },
  computed: {
    pwSaveDisabled() {
      const defaultPw = this.basicinfo['VMBASIC/VM_DEFAULT_PASSWORD'];
      return !(defaultPw.isModified) || defaultPw.value.length === 0;
    },
    pwCancelDisabled() {
      const defaultPw = this.basicinfo['VMBASIC/VM_DEFAULT_PASSWORD'];
      return !(defaultPw.isModified);
    },
    expireSaveDisabled() {
      const notifyDate = this.basicinfo['VMEXPIRE/VMEXPIRE_NOTIFY_DATE'];
      const expireDate = this.basicinfo['VMEXPIRE/VMEXPIRE_DATE'];
      const autoDelete = this.basicinfo['VMEXPIRE/VMEXPIRE_AUTO_DELETE'];
      return !(notifyDate.isModified || expireDate.isModified || autoDelete.isModified);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * boolean유틸의 isTrue
     * @author jeee12
     */
    isTrue,
    /**
     * 프로비저닝 기본정보 전체 로드
     * @author jeee12
     */
    loadData() {
      provisioningSettingsAPI.getProvisioningBasicinfo({}).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.setBasicinfo(result);
        }
      });
    },
    /**
     * 프로비저닝 기본정보 > 패스워드 / 회수폐기 설정 각 form별 데이터 로드
     * @author jeee12
     * @param  {[type]} basicinfoId [description]
     * @return {[type]}             [description]
     */
    loadFormData(basicinfoId) {
      basicinfoSetAPI.getList(basicinfoId).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.setBasicinfo(result);
        }
      });
    },
    /**
     * basicinfo, originBasicinfo 설정
     * @author jeee12
     * @param  {[type]} basicinfos 데이터 조회 결과 list
     */
    setBasicinfo(basicinfos) {
      basicinfos.forEach((data) => {
        const datatypeId = data.datatypeId === 'BOOL' ? 'BOOLEAN' : data.datatypeId;
        this.basicinfo[`${data.basicinfoId}/${data.basicinfoSubid}`] = {
          value: data[camelCase(`basicinfoSubvalue${datatypeId}`)],
          datatypeId,
          isModified: false,
        };
      });
      this.originBasicinfo = cloneDeep(this.basicinfo);
    },
    /**
     * 저장 버튼 클릭
     * @author jeee12
     * @param  {[type]} basicinfoId 저장할 basicinfoId
     */
    onSaveButtonClick(basicinfoId) {
      const target = '정보';
      const action = msgUtil.action.SAVE;
      const params = [];
      mapKeys(this.basicinfo, (value, key) => {
        const isMatched = key.indexOf(basicinfoId) > -1;
        if (isMatched && value.isModified) {
          const basicinfoSubid = key.split('/')[1];
          const subValueKey = camelCase(`basicinfoSubvalue${value.datatypeId}`);
          const subValue = value.datatypeId === 'INTEGER' ? Number(value.value) : value.value;
          params.push({
            basicinfoId,
            basicinfoSubid,
            [subValueKey]: subValue,
          });
        }
      });

      basicinfoSetAPI.updateList(params).then((response) => {
        if (response.data.success) {
          this.loadFormData(basicinfoId);
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 대상값에 대한 수정여부 체크
     * @author jeee12
     * @param  {[type]} value     change 또는 keyup 이벤트 대상 값
     * @param  {[type]} basicinfoKey 대상값의 key
     */
    changeTargetValue(value, basicinfoKey) {
      if (basicinfoKey === 'VMBASIC/VM_DEFAULT_PASSWORD' || !isNaN(value)) {
        // 기본 패스워드(문자 허용) 또는 회수폐기 설정(문자 불가)
        const changedInfo = this.basicinfo;
        const originInfo = this.originBasicinfo;
        this.basicinfo[basicinfoKey].isModified = !isEqual(changedInfo[basicinfoKey].value, originInfo[basicinfoKey].value);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/virtual/Provisioning/BasicInfoSetting/index.vue